import React from 'react';
/*import Select from 'react-select';*/
import classnames from 'classnames';
import { toast } from 'react-toastify';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.min.css';
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import {ButtonValidation} from '../../../../component/Button.js';
import {Exec} from '../../../../helper/request.action.js'
import SelectQuery from '../../../../component/SelectQuery.js';
import Request from '../../../../config/Request.js';

export default class ModalInsertTag extends React.Component {
	constructor(){
		super()
		this.initialState = {
			asset 			: null,
			tag 				: null,
			tagBox 			: false,
			inProcess 	: false,
			isLinked 		: false,
			isChecking	: false,
			isAllowed 	: true,
			overflow 		: 'hidden'
		}
		this.state = Object.assign({}, this.initialState)
		this.onCheckTagSuccess = this.onCheckTagSuccess.bind(this);
		this.onCheckTagFailed = this.onCheckTagFailed.bind(this);
		this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
		this.onUpdateFailed = this.onUpdateFailed.bind(this);
		this.willUnMount = this.willUnMount.bind(this)
		// this.willMount = this.willMount.bind(this)
	};

	generateLabel(MasterReducer, type) {
	  let OptionAutoComplete = [];
	  for(let i = 0 ; i < MasterReducer.length; i++) {
	    OptionAutoComplete.push(
	      {
	      	value: MasterReducer[i].Alias,
	      	label: MasterReducer[i].Name + ' (' + MasterReducer[i].Alias + ')'
	      }
	    )
	  }
	  return OptionAutoComplete
	}

	onOpen() {
	  this.setState({overflow: 'visible'})
	}

	onClose() {
	  this.setState({overflow: 'hidden'})
	}

	handleCheckboxChange(event) {
	    this.setState({
	      tagBox: event.target.checked,
	    })
	}

	save(){
		this.updateParams = {
			Asset : this.state.asset,
			Tag : this.state.tag
		}

		if(this.updateParams.Asset === null || this.updateParams.Asset === ''){
			toast.error('Asset Empty!')
			return
		}

		Presenter.Update(
			RequestProperties.Update(
				'link', this,
				this.onUpdateSuccess,
				this.onUpdateFailed
			)
		)
		this.setState({ inProcess : true })
	};

	addNewAsset(){
		this.props.RunRedux(Exec("SetAssetTag", {
			tag : this.state.tag
		}))
		this.props.history.push('/admin/master-asset-registration')
		this.props.closeModal();
	}

	onUpdateSuccess(params, response){
		toast.success('Tag Linking Succeded')
		this.setState({
			inProcess	: false,
			isLinked	: true
		})
	};

	onUpdateFailed(params, response){
		toast.error(response.data.detail)
		this.setState({
			inProcess	: false,
		})
	};

	onCheckTag(tag){
		this.setState({isChecking:true});
		Request(
			"get", "check-tag",
			{Authorization: "Bearer " + this.props.UserReducer.token},
			{}, [tag],
			this.onCheckTagSuccess,
			this.onCheckTagFailed,
		)
	};

	onCheckTagSuccess(response){
		this.setState({
			isChecking	: false,
			isAllowed	: response.data.allow
		})
	};

	onCheckTagFailed(error){
		this.setState({isChecking:false})
	};

	// willMount(){
		// this.onCheckTag(this.state.tag)
	// };

	willUnMount(){
		this.setState(this.initialState)
	};

	renderContent(){
		const {isChecking, isAllowed} = this.state
		if(!isChecking){
			if(isAllowed){
				return (
					<div className="isRepeatLabel" style={{margin : 0}}>
						<label className="spaceRRR mb0">Do you want to link scanned Tag to the Asset ?</label>
						<label className="switch switch-md switch-text switch-primary mb0">
						  <input
						    onChange={(event)=>this.handleCheckboxChange(event)}
						    name='isRepeat'
						    type="checkbox"
						    className="switch-input"
						    checked={this.state.tagBox}
						    disabled={this.state.isLinked}
						  />
						  <span className="switch-label" data-on="Yes" data-off="No"></span>
						  <span className="switch-handle"></span>
						</label>
					</div>
				)
			}else{
				return(
					<div className="isRepeatLabel" style={{margin : 0}}>
						<label className="spaceRRR mb0">Tag Already Used!</label>
					</div>
				)
			}
		}else{
			return (
				<div className="isRepeatLabel" style={{margin : 0}}>
					<span><i className="fa fa-spinner fa-pulse fa-fw" />&nbsp;<i>Checking Tag...</i></span>
				</div>
			)
		}
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.newTag !== null){
			this.setState({tag : nextProps.newTag})
		}
	};

	render(){
		return(
			<Modal
				isOpen	= {this.props.isOpen}
				toggle 	= {this.props.closeModal}
				onExit	= {this.willUnMount}
				// onEnter = {this.willMount}
			>
				<ModalHeader toggle={this.props.closeModal}><i className="fa fa-qrcode"></i>&nbsp;Link Tag to The Asset</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-12">
							{this.renderContent()}
						</div>
						<div
							className={classnames('isRepeatBox', {open: this.state.tagBox})}
							style={{
								'overflow': this.state.overflow,
								'marginBottom':0
							}}
						>
						  <div className="row">
						    <div className="form-group col-sm-12" style={{'paddingTop': '13px'}}>
									<label>Link new tags to existing assets</label>
									<div className="input-group">
		              	<SelectQuery
		                	placeholder="Type Asset"
		                  value={this.state.asset}
		                  className="form-control no-padding no-border"
		                  onChange={(e) => this.setState({asset: e.value})}
		                  urlKey="read-asset-autocomplete"
		                  valKey="Alias"
		                  valLabel="Name"
		                  isCreatable={false}
		                  UserReducer={this.props.UserReducer}
		                  onOpen={()=>this.onOpen()}
		                  onClose={()=>this.onClose()}
											disabled={this.state.isLinked}
						         />
										 <span className="input-group-btn" hidden={this.state.isLinked}>
										 	<ButtonValidation
												is_process={this.state.inProcess}
												style={{marginLeft: '8px'}}
												onClick={()=>this.save()}>Save</ButtonValidation>
											</span>
									</div>

									<div className="divider-with-text" hidden={this.state.isLinked}>
									  <span className="text-divider">OR</span>
									</div>

							    <div style={{'paddingTop': '13px', 'textAlign': 'center'}} hidden={this.state.isLinked}>
										<button
											className = "btn btn-primary"
											onClick = {() => this.addNewAsset()}>Link new tags to new assets</button>
							    </div>

						    </div>
						  </div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={() => {this.props.closeModal(); this.props.openModalQRScanner()}}>Re-Scan</Button>
					<Button color="danger" onClick={this.props.closeModal}>Close</Button>
				</ModalFooter>
			</Modal>
		)
	};
}



// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/Modal/ModalInsertTag.jsx